"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../../types");
exports.default = (_a = {},
    _a[_types_1.Network.mainnet] = {
        POOL_FACTORY: "0xa03492A9A663F04c51684A3c172FC9c4D7E02eDc",
    },
    _a[_types_1.Network.rinkeby] = {
        POOL_FACTORY: "0x5a8b70edfd28A79756B54ed8DbeeE13e566920Aa",
    },
    _a[_types_1.Network.goerli] = {
        POOL_FACTORY: "0x4D6BFD9B8226A2d95629B8f65c3B9F6F0d7a3e8B",
    },
    _a[_types_1.Network.polygon] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.mumbai] = {
        POOL_FACTORY: "0x267bF4a003CAF380D94766492Bf7FEc82a5dd9DC",
    },
    _a[_types_1.Network.binance] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.binanceTestnet] = {
        POOL_FACTORY: "0x4AE593b77234dB644a6d6443C89a447140aeb361",
    },
    _a[_types_1.Network.fantom] = {
        POOL_FACTORY: "0xb4FD0Ce108e196d0C9844c48174d4C32Cd42F7bC",
    },
    _a[_types_1.Network.fantomTestnet] = {
        POOL_FACTORY: "0x4AE593b77234dB644a6d6443C89a447140aeb361",
    },
    _a);
